import { render, staticRenderFns } from "./readingbanddialog.vue?vue&type=template&id=5fc0f3ca&scoped=true"
import script from "./readingbanddialog.vue?vue&type=script&lang=js"
export * from "./readingbanddialog.vue?vue&type=script&lang=js"
import style0 from "./readingbanddialog.vue?vue&type=style&index=0&id=5fc0f3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0f3ca",
  null
  
)

export default component.exports